module.exports = __webpack_public_path__ + "static/media/my_reads.d30b6033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_reads.jpg
// module id = 57
// module chunks = 0